// test1093
(1093 && 0);
